import { createAction } from '@reduxjs/toolkit';

export const PRIORITIZE_QUEUED_ACTION_TYPE = 'saga/prioritizeQueued';
export const prioritizeQueuedAction = createAction(PRIORITIZE_QUEUED_ACTION_TYPE);
